/* v8 ignore start -- @preserve */

import { QueryCache, QueryClient } from "@tanstack/react-query";

export const DEFAULT_INTERVAL = 10 * 60 * 1000;

export const QueryClientInstance = new QueryClient({
  defaultOptions: {
    queries: {
      refetchInterval: DEFAULT_INTERVAL,
      refetchIntervalInBackground: false,
      refetchOnMount: true,
      refetchOnReconnect: false,
      retry: false, // Disable retries by default - retries are handled at axios level
    },
    mutations: {
      retry: false, // Disable retries for mutations as well
    },
  },
  queryCache: new QueryCache(),
});
